/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */

import {
  MessageType,
  KeyboardParserFactory,
  MouseParserFactory,
  EventParserFactory,
  ResizeParserFactory,
} from '@acs-manageability/core'
import { emit } from './EventUtils'

import {
  setEventParser,
  setKeyboardParser,
  setMouseParser,
  setResizeParser,
} from '@acs-manageability/webrtc-react'

// let reloadTask = null;
// let lastReloadTime = 0;

export default (broker) => {
  let signaling = null
  let globalMessages = {}

  const connect = (url) => {
    signaling = new WebSocket(url)
  }

  const onopen = (callback) => {
    signaling.onopen = callback
  }

  const onerror = (callback) => {
    signaling.onerror = callback
  }

  const setGlobalMessages = (params) => {
    globalMessages = params || {}
  }

  const sendMessage = (message) => {
    const { content, message_type } = message
    const messageContent = broker.getMessageInfo(content, message_type) || content
    const sendMsg = {
      ...message,
      ...globalMessages,
    }
    console.log('[--- Send ---]', {
      ...sendMsg,
      content: messageContent,
    })
    signaling?.send(JSON.stringify(sendMsg))
  }

  const setMessageHandler = ({
    onHelloRespMessage,
    onAuthenticateRespMessage,
    onGetResourcesListRespMessage,
    onResendAllocateMessage,
    onAllocateRespMessage,
    onTurnAuthenticationRespMessage,
    onError,
    onClose,
    onAddIceCandidate,
    onOffer,
    onAnswer,
  }) => {
    signaling.onmessage = async (message) => {
      const data = JSON.parse(message.data)

      if (!data) {
        return
      }
      // console.log('[--- Receive ---]', data);
      let resetTimeout = true

      const { message_type, error, warning, content } = data
      try {
        switch (message_type) {
          case MessageType.HELLO_RESP:
            onHelloRespMessage(content)
            break

          case MessageType.AUTHENTICATE_RESP:
            onAuthenticateRespMessage(content)
            break

          case MessageType.INITIATE_RESP:
            const keyboardParser = KeyboardParserFactory.createParser(
              content.components.input.protocol_version,
            )
            const mouseParser = MouseParserFactory.createParser(
              content.components.input.protocol_version,
            )
            const eventParser = EventParserFactory.createParser(
              content.components.input.protocol_version,
            )
            const resizeParser = ResizeParserFactory.createParser(
              content.components.input.protocol_version,
            )

            setEventParser(eventParser)
            setKeyboardParser(keyboardParser)
            setMouseParser(mouseParser)
            setResizeParser(resizeParser)
            break
          case MessageType.GET_RESOURCES_RESP:
            onGetResourcesListRespMessage(content)
            break

          case MessageType.ALLOCATE_RESP:
            if (error || warning) {
              resetTimeout = false
              // clearTimeout(reloadTask);
              // if (lastReloadTime === 0) {
              // 	lastReloadTime = Date.now();
              // }
              // if (Date.now() - lastReloadTime < 10000) {
              // 	reloadTask = setTimeout(() => {
              // 		onResendAllocateMessage();
              // 	}, 2500);
              // } else {
              // 	emit('kvm_status_changed', { error: 'allocate_error' });
              // }
              onResendAllocateMessage()
            } else {
              emit('kvm_status_changed', { step: 'establish_candidate' })
              onAllocateRespMessage(content)
            }
            break

          case MessageType.GET_TURN_CREDENTIALS_RESP:
            onTurnAuthenticationRespMessage(content)
            break

          case MessageType.ERROR:
            onError(content)
            break

          case MessageType.AUTH_ERROR:
            onError(content)
            break

          case MessageType.SDP:
            if (content.type === 'offer') {
              await onOffer(content, sendMessage)
            } else if (content.type === 'answer') {
              await onAnswer(content)
            } else {
              console.log('Unsupported SDP type.')
            }
            break

          case MessageType.CANDIDATE:
            if (content) {
              await onAddIceCandidate(content)
            }
            break

          default:
            // console.error(data);
            break
        }
      } catch (err) {
        console.error(err)
      }
      if (resetTimeout) {
        emit('reset_timeout_check_task', {})
      }
    }

    signaling.onclose = (e) => {
      switch (e.code) {
        case 1006:
          onClose('An error occurred connecting to the specified proxy server.')
          break
        default:
          break
      }
    }
  }

  return {
    connect,
    onopen,
    onerror,
    setGlobalMessages,
    setMessageHandler,
    sendMessage,
  }
}
